import { StoreConfig } from "types/state";

export default function configureStore(): StoreConfig {
  const config = require("./configureStore").default;
  return config();
}
